import { Grid } from '@mui/material';
import { Location } from '@nx-smartmonkey/shared/domain';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { forwardRef } from 'react';

import AddStopIcon from '../../../../assets/img/add-stop-icon.svg';
import RemoveStopIcon from '../../../../assets/img/remove-stop-icon.svg';
import { Text } from '../../../../react-components/Text';

type LocationPillProps = {
  location: Location;
  containerStyles?: React.CSSProperties;
  icon: `add` | `remove`;
  onSelectLocation?: () => void;
  onClickOverIcon?: () => void;
};

export const LocationPill = forwardRef<HTMLDivElement, LocationPillProps>(
  ({ location, containerStyles, icon, onSelectLocation, onClickOverIcon }, ref) => {
    return (
      <Grid
        ref={ref}
        container
        direction="row"
        wrap="nowrap"
        alignItems="center"
        style={{
          minHeight: `30px`,
          zIndex: `1001`,
          padding: `20px 0`,
          ...containerStyles,
        }}
        onClick={() => {
          if (onSelectLocation) {
            onSelectLocation();
          }
        }}
      >
        <Grid item style={{ width: `calc(100% - 24px)` }}>
          <Text
            variant="body-large"
            style={{
              color: RoutalPalette.primary80,
            }}
          >
            {location.label ?? location.toString()}
          </Text>
        </Grid>

        <img
          onClick={(e) => {
            e.stopPropagation();
            if (onClickOverIcon) {
              onClickOverIcon();
            }
          }}
          src={icon === `add` ? AddStopIcon : RemoveStopIcon}
          alt=""
          draggable="false"
          width="24"
          style={{ marginLeft: `10px` }}
        />
      </Grid>
    );
  }
);
